module.exports = __webpack_public_path__ + "img/tiki.beb82190.jpeg";